var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Text } from '@inter-ikea-kompis/component-text';
import { Tooltip } from '@inter-ikea-kompis/component-tooltip';
import { Button as SkapaButton, IconButton as SkapaIconButton } from '@ingka/button-webc/passive.js';
import { checkmark, copy, registerIcon } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import { Tooltip as SkapaTooltip } from '@ingka/tooltip-webc/passive.js';
import CopyDesignCodeStateEnum from '../../enums/CopyDesignCodeStateEnum.js';
import CopyDesignCodeStyle from './CopyDesignCodeStyle.js';
/**
 * CopyCode class.
 *
 * @event copy Click on copy button
 * @event reset Sent after 3 seconds after state success.
 */
export default class CopyDesignCode extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // State information
        this.state = CopyDesignCodeStateEnum.default;
        this.timeout = null;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        const { designCodeTitle } = this.getTranslations();
        const tertiaryVariant = 'tertiary';
        return html `
			<style>
				${CopyDesignCodeStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="container">
				<kompis-text
					class="copyDesignCode"
					.theme="${this.theme}"
					.type="${ThemeFontStyleTypeEnum.bodyMedium}"
				>
					${designCodeTitle}
				</kompis-text>
				<kompis-text class="designCode" .bold="${true}" .theme="${this.theme}">
					${this.vpcCode}
				</kompis-text>
				<skapa-tooltip position="trailing">
					<skapa-icon-button
						slot="custom-trigger"
						variant="${tertiaryVariant}"
						size="small"
						@click="${this.onCopyClick.bind(this)}"
					>
						${this.getTooltipText()}
						<skapa-icon
							slot="icon"
							icon="${this.state === CopyDesignCodeStateEnum.success ? 'checkmark' : 'copy'}"
						></skapa-icon>
					</skapa-icon-button>
					${this.getTooltipText()}
				</skapa-tooltip>
			</div>
		`;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
    async connectedCallback() {
        registerIcon(copy);
        registerIcon(checkmark);
        this.customElements.define('skapa-button', SkapaButton);
        this.customElements.define('skapa-icon-button', SkapaIconButton);
        this.customElements.define('skapa-icon', SkapaIcon);
        this.customElements.define('skapa-tooltip', SkapaTooltip);
        this.customElements.define('kompis-text', Text);
        this.customElements.define('kompis-tooltip', Tooltip);
        super.connectedCallback();
    }
    shouldUpdate(changedProperties) {
        if (changedProperties.has('state')) {
            const tooltip = this.shadowRoot?.querySelector(this.customElements.getInternalName('skapa-tooltip'));
            if (this.state === CopyDesignCodeStateEnum.success) {
                tooltip?.setAttribute('toggle', 'true');
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.dispatchEvent(new CustomEvent('reset', { bubbles: true }));
                }, 3000);
            }
            else if (this.state === CopyDesignCodeStateEnum.default) {
                tooltip?.removeAttribute('toggle');
            }
        }
        return true;
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
    getTranslations() {
        return this.translations
            ? this.translations
            : this.localizedInformation?.translations;
    }
    /**
     * Message to user.
     *
     * @returns Template.
     */
    getTooltipText() {
        if (this.state === CopyDesignCodeStateEnum.default) {
            return this.getTranslations().copyCodeTooltip;
        }
        return this.getTranslations().copyCodeSuccessMessage;
    }
    /**
     * Click event for button for copy.
     */
    async onCopyClick() {
        let thrownError = null;
        try {
            await navigator.clipboard.writeText(this.vpcCode);
        }
        catch (error) {
            thrownError = error;
        }
        this.dispatchEvent(new CustomEvent('copy', {
            bubbles: true,
            detail: {
                state: !thrownError ? CopyDesignCodeStateEnum.success : CopyDesignCodeStateEnum.default,
                error: thrownError?.message
            }
        }));
        if (thrownError) {
            throw thrownError;
        }
    }
}
__decorate([
    property({ type: Object, required: true })
], CopyDesignCode.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], CopyDesignCode.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], CopyDesignCode.prototype, "translations", void 0);
__decorate([
    property({ type: String, required: true })
], CopyDesignCode.prototype, "vpcCode", void 0);
__decorate([
    property({ type: String })
], CopyDesignCode.prototype, "state", void 0);
//# sourceMappingURL=CopyDesignCode.js.map